import { FileRecord } from '../types/files';

/**
 * Check if a file is managed by an external module
 */
export function isManagedByModule(file: FileRecord): boolean {
  return file.metadata?.managedByModule === 'true';
}

/**
 * Get the module owner of a file
 */
export function getModuleOwner(file: FileRecord): string | undefined {
  return file.metadata?.moduleOwner;
}

/**
 * Get the module display name for a file
 */
export function getModuleDisplayName(moduleOwner: string | undefined): string {
  if (!moduleOwner) return '';

  const displayNames: Record<string, string> = {
    trade: 'Trade',
    sales: 'Sales',
    transportation: 'Transportation',
  };

  return displayNames[moduleOwner] || moduleOwner;
}

/**
 * Check if a file can be deleted
 */
export function canDeleteFile(file: FileRecord): boolean {
  return !isManagedByModule(file);
}

/**
 * Check if a file can be moved
 */
export function canMoveFile(file: FileRecord): boolean {
  return !isManagedByModule(file);
}

/**
 * Check if a file can be renamed
 */
export function canRenameFile(file: FileRecord): boolean {
  return !isManagedByModule(file);
}

/**
 * Get the attachment type from file metadata
 */
export function getAttachmentType(file: FileRecord): string | undefined {
  return file.metadata?.attachmentType;
}

/**
 * Get the entity type this file is attached to
 */
export function getEntityType(file: FileRecord): string | undefined {
  return file.metadata?.entityType;
}

/**
 * Get the entity ID this file is attached to
 */
export function getEntityId(file: FileRecord): string | undefined {
  return file.metadata?.entityId;
}

/**
 * Build a display label for a module-managed file
 */
export function buildModuleLabel(file: FileRecord): string | null {
  if (!isManagedByModule(file)) return null;

  const moduleOwner = getModuleOwner(file);
  const displayName = getModuleDisplayName(moduleOwner);

  return `${displayName} Managed`;
}
